import { useState } from "react";
import Button from "@material-ui/core/Button";
import axiosInstance from "../../utils/config";
import Joi from "joi";
import CancelOutlined from "@material-ui/icons/Clear";
import PswdShown from "@material-ui/icons/Visibility";
import PswdHidden from "@material-ui/icons/VisibilityOff";
import "../styles.css";

function NewCreative(props) {
  const { display } = props,
    [successMsg, setSuccessMsg] = useState({
      status: false,
      message: null,
    }),
    [isPasswordShown, setIsPasswordShown] = useState(false),
    changePswdVisibility = (action) => {
      action === "hide" ? setIsPasswordShown(false) : setIsPasswordShown(true);
    },
    schemaMap = {
      Names: Joi.string().required().max(40).min(5).label("Fullname field"),
      Email: Joi.string()
        .max(100)
        .min(5)
        .required()
        .email({ tlds: { allow: false } })
        .label("Email field"),
      Password: Joi.string().required().max(25).min(6).label("Password field"),
    };
  const schema = Joi.object(schemaMap);
  const [formErrors, setFormErrors] = useState({
    namesError: "",
    emailError: "",
    passwordError: "",
  });
  const [userInfo, setUserInfo] = useState({
      Names: "",
      Email: "",
      Password: "",
    }),
    hidePopup = () => {
      props.setPopupDisplay("none");
      document.body.style.overflow = "auto";
      setUserInfo({
        Names: "",
        Email: "",
        Password: "",
      });
    },
    handleChange = () => {
      const options = { abortEarly: false };
      const { error } = schema.validate(userInfo, options);
      if (!error) setSuccessMsg({ status: true, message: "" });
      else setSuccessMsg({ status: false, message: "" });
    },
    handleSubmit = (e) => {
      e.preventDefault();
      const options = { abortEarly: false };
      const { error } = schema.validate(userInfo, options);
      if (error) {
        const errors = {};
        for (let item of error.details) {
          errors[item.path[0]] = item.message;
        }
        setFormErrors({
          namesError: errors.Names,
          emailError: errors.Email,
          passwordError: errors.Password,
        });
      } else {
        const { Names, Email, Password } = userInfo;
        setSuccessMsg({ status: null, message: null });
        setFormErrors({
          namesError: "",
          emailError: "",
          passwordError: "",
        });
        console.log(userInfo);
        axiosInstance
          .post(
            "/creatives/register",
            {
              Names,
              Email,
              Password,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Bearer " + localStorage?.getItem("skiUserToken"),
              },
            }
          )
          .then((data) => {
            setSuccessMsg({
              status: true,
              message: "New Creative was successfully invited.",
            });
            setFormErrors({
              namesError: "",
              emailError: "",
              passwordError: "",
            });
            window.location.reload();
            setTimeout(() => {
              props.setPopupDisplay("none");
            }, 2000);
          })
          .catch((err) => {
            setFormErrors({
              namesError:
                "Error. Email may be already taken or may be you are offline..",
              emailError: "",
              passwordError: "",
            });
            if (err.response) {
              setSuccessMsg({
                status: false,
                message: err.response.data,
              });
            }
          });
      }
    };
  return (
    <div className="NewUserPopup" style={{ display }}>
      <div
        className="PopupTransparentBg"
        id="PopupTransparentBg"
        onClick={() => hidePopup()}
      ></div>
      <div className="NewUserContent">
        <div className="NewUserHeader">
          <Button onClick={() => hidePopup()} title="Close">
            <CancelOutlined />
          </Button>
        </div>
        {successMsg.message && successMsg.status ? (
          <div className="alert alert-success text-center" role="alert">
            {successMsg.message}
          </div>
        ) : (
          ""
        )}
        {formErrors.namesError ? (
          <p className="my-3 error">{formErrors.namesError}</p>
        ) : formErrors.emailError ? (
          <p className="my-3 error">{formErrors.emailError}</p>
        ) : formErrors.passwordError ? (
          <p className="my-3 error">{formErrors.passwordError}</p>
        ) : (
          ""
        )}
        <form
          action="/"
          method="POST"
          autoComplete="off"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div>
            <input
              type="text"
              name="fullName"
              placeholder="Names"
              onChange={(e) => {
                setUserInfo({ ...userInfo, Names: e.target.value });
                handleChange();
              }}
              required
            />
            <input
              type="email"
              name="userEmail"
              placeholder="Email"
              onChange={(e) => {
                setUserInfo({ ...userInfo, Email: e.target.value });
                handleChange();
              }}
              required
            />
          </div>
          <div style={{ position: "relative" }}>
            <input
              type={isPasswordShown ? "text" : "password"}
              name="userPassword"
              placeholder="Password"
              onChange={(e) => {
                setUserInfo({ ...userInfo, Password: e.target.value });
                handleChange();
              }}
              required
            />
            {isPasswordShown ? (
              <PswdShown
                titleAccess="Hide password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("hide")}
                style={{ right: "55%" }}
              />
            ) : (
              <PswdHidden
                titleAccess="Show password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("show")}
                style={{ right: "55%" }}
              />
            )}
          </div>
          <div>
            <input type="submit" value="Add Creative" />
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewCreative;
